// @ts-strict-ignore
import { Dictionary } from 'typescript-collections';
import { ArticleVO } from '../../model/vo/article.vo';
import { ArticleInfoVO, ComplexProjectVO } from '@project/model/vo/project.vo';
import { CloneUtils } from '@shared/util/clone-utils';
import { ArticleUtils } from '../../util/article-utils';

export class ArticleRefreshData {
  public dynamicArticlesMap: Dictionary<string, ArticleVO>;
  public dynamicArticlesInfo: ArticleInfoVO[];
  public isArticleRepresentationsEnabled: boolean = false;
  public delayDynamicArticleFinalization: boolean = false;
  public deleteUnusedConnections: boolean = true;
  public updateTextures: boolean = true;

  public static createFromProject(complexProject: ComplexProjectVO): ArticleRefreshData {
    const data: ArticleRefreshData = new ArticleRefreshData();
    data.dynamicArticlesMap = CloneUtils.cloneDynamicArticlesMap(complexProject.dynamicArticlesMap);
    const dynamicArticlesInfo: ArticleInfoVO[] = this.removeDuplicatedValues(complexProject.project.dynamicArticlesInfo);
    data.dynamicArticlesInfo = CloneUtils.cloneArticleInfoVOs(dynamicArticlesInfo);
    return data;
  }

  private static removeDuplicatedValues(source: ArticleInfoVO[]): ArticleInfoVO[] {
    if (!source) {
      return null;
    }

    const result: ArticleInfoVO[] = [];
    for (const value of source) {
      if (result.indexOf(value) === -1) {
        result.push(value);
      }
    }
    return result;
  }

  public addDynamicArticleToMap(usageId: string, dynamicArticle: ArticleVO): void {
    if (!usageId || !dynamicArticle) {
      return;
    }

    if (!this.dynamicArticlesMap) {
      this.dynamicArticlesMap = new Dictionary<string, ArticleVO>();
    }
    this.dynamicArticlesMap.setValue(usageId, dynamicArticle);
  }

  public addDynamicArticleInfo(articleInfo: ArticleInfoVO): void {
    if (!articleInfo) {
      return;
    }

    if (!this.dynamicArticlesInfo) {
      this.dynamicArticlesInfo = [];
    }
    this.dynamicArticlesInfo.push(articleInfo);
  }

  public updateArticleInfo(fromId: string, toId: string): void {
    const articleInfo: ArticleInfoVO = ArticleUtils.findArticleInfoByGuidInSource(fromId, this.dynamicArticlesInfo);
    if (articleInfo) {
      articleInfo.guid = toId;
    }
    if (this.dynamicArticlesMap && this.dynamicArticlesMap.containsKey(fromId)) {
      const article: ArticleVO = this.dynamicArticlesMap.getValue(fromId);
      this.dynamicArticlesMap.remove(fromId);
      this.dynamicArticlesMap.setValue(toId, article);
    }
  }
}
